module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider"
  }, [_vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      staticClass: "slide",
      class: {
        "slide-active": index == _vm.activeSlide
      }
    }, [_c('div', {
      staticClass: "slide-content"
    }, [_c('h1', {
      staticClass: "slide-title"
    }, [_vm._v(_vm._s(slide.title))]), _c('h4', {
      staticClass: "slide-text"
    }, [_vm._v(_vm._s(slide.text))]), _vm._m(0, true)]), _c('div', {
      staticClass: "slide-overlay"
    }), _c('figure', {
      staticClass: "slide-img"
    }, [_c('img', _vm._b({
      attrs: {
        "alt": "Welcome picture"
      }
    }, 'img', {
      src: _vm.loadImage(slide.name),
      class: [("img-" + (slide.name))]
    }))])])
  }), _c('nav', {
    staticClass: "slider-nav"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('a', {
      staticClass: "nav-point",
      class: {
        "point-active": index == _vm.activeSlide
      },
      on: {
        "click": function($event) {
          _vm.changeSlide(index)
        }
      }
    })
  })), _c('a', {
    staticClass: "nav-arrow arrow-prev",
    on: {
      "click": function($event) {
        _vm.changeSlide("prev")
      }
    }
  }), _c('a', {
    staticClass: "nav-arrow arrow-next",
    on: {
      "click": function($event) {
        _vm.changeSlide("next")
      }
    }
  })], 2), _c('section', {
    staticClass: "about"
  }, [_vm._m(1), _c('div', {
    staticClass: "about-video"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": "https://goo.gl/aieVs4"
    }
  })], 1)]), _vm._m(2), _c('section', {
    staticClass: "awards"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("AWARDS")]), _vm._l((4), function(n) {
    return _c('div', {
      staticClass: "awards-item"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/index/award-logo.svg"),
        "alt": "Awwwwards"
      }
    })])
  })], 2), (_vm.sortTopProducts) ? _c('section', {
    staticClass: "gallery"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("GALLERY")]), _vm._l((_vm.topProducts), function(product) {
    return _c('div', {
      staticClass: "gallery-product"
    }, [_c('figure', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    }), _c('div', {
      staticClass: "img-overlay"
    }, [_c('h2', {
      staticClass: "overlay-title"
    }, [_vm._v(_vm._s(product.name))]), _c('p', {
      staticClass: "overlay-author"
    }, [_vm._v(_vm._s(product.author))])])])])
  })], 2) : _vm._e(), _c('section', {
    staticClass: "comments"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("COMMENTS")]), _vm._l((4), function(n) {
    return _c('div', {
      staticClass: "comment"
    }, [_vm._m(3, true), _c('cite', {
      staticClass: "comment-author"
    }, [_vm._v("Alex, Google")]), _c('blockquote', {
      staticClass: "comment-text"
    }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.")])], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-action"
  }, [_c('a', [_vm._v("Read more")]), _c('a', [_vm._v("See works")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-item"
  }, [_c('h2', {
    staticClass: "about-title"
  }, [_vm._v("PXLSHOP is a platform for handcrafted, mousemade design content\nfrom independent creatives around the world.")]), _c('p', {
    staticClass: "about-text"
  }, [_vm._v("Pxlshop, a global technology company, has created a great two-sided\nmarketplace for creative professionals to license content - including\nimages, videos and music - as well as innovative tools that power the\ncreative process.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "info"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("INFO")]), _c('div', {
    staticClass: "info-item"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("We kind to our authors")]), _c('p', [_vm._v("Artists are at the heart of everything we do and the reason why\npxlshop continues to be an important destination for stock content.\nBy providing a platform for our artists to distribute some of the best\nstock content in the world, we give them the opportunity to\ntransform their lives by making a living through their art.")])]), _c('div', {
    staticClass: "info-item"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("We kind to our culture")]), _c('p', [_vm._v("We are where art starts, but that's only the beginning. We are the\nmovement for the liberation of creative expression. We believe that\nart is for everyone, and we're creating the cultural context for how\nit is created, discovered, and shared.")])]), _c('div', {
    staticClass: "info-item"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v("We kind to our clients")]), _c('p', [_vm._v("Registration is free and gives you access to browse thousands of\nprofessional royalty-free stock photos, illustrations and patterns.\nFind great files from the world’s top contributors at the lowest\nprices. We always welcome to customize all our plans to suit your needs.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "comment-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/avatar.svg"),
      "alt": "Author avatar"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ca1ce8c8"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Index.vue
// module id = 133
// module chunks = 0